;(function() {
  'use strict'

  angular.module('app.core').component('quotaPlanDialog', {
    controller: Controller,
    templateUrl: 'quota-plan-dialog.html',
    bindings: {
      dialogTitle: '<',
      confirmLabel: '<',
      name: '<',
      showIntro: '<',
      onConfirm: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    var MAX_NAME_LENGTH = 30

    ctrl.$onInit = onInit
    ctrl.getError = getError
    ctrl.canConfirm = canConfirm
    ctrl.confirm = confirm

    function onInit() {
      ctrl.value = ctrl.name || ''
    }

    function getError() {
      if (getValue().length > MAX_NAME_LENGTH) {
        return 'Keep the name to ' + MAX_NAME_LENGTH + ' characters or fewer.'
      }
      return null
    }

    function canConfirm() {
      return !!getValue().length && !getError()
    }

    function confirm() {
      if (!canConfirm()) return

      ctrl.onConfirm({ $name: getValue() })
    }

    function getValue() {
      return (ctrl.value || '').trim()
    }
  }
})()
